module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/191-tonga-6c74166c2fa1bc8692e952dbaf6c4518.svg";